import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/OnboardedSolutionDetails.css";
import { fetchData, postData, postFormData} from "../api/restapi";

function DeliveryReadySolutionDetailsTab() {
    console.log("DELIVERY_READY tab")
    const [solutions, setSolutions] = useState([]);
    const [detailsPopup, setDetailsPopup] = useState(null);

    const solutionColumns = [
        { key: "solutionId", label: "Solution Id", isClickable: true },
        { key: "description", label: "Solution Description" },
        { key: "state", label: "State" }
    ];

    useEffect(() => {
        const params = { state: "DELIVERY_READY" };
        fetchData(`/qfm/v1/solutions/portal/solutions?state=${params.state}`).then((data) => {
            setSolutions(data.solutions || []);
        });
    }, []);

    const openDetailsPopup = (solutionId, licenses = [], mbns = []) => {
        setDetailsPopup({ solutionId, licenses, mbns });
    };

    const closeDetailsPopup = () => {
        setDetailsPopup(null);
    };

    return (
        <div className="osln-tab-container">
            {detailsPopup && <div className="overlay"></div>}
            <div className="tab-heading">
                <h1>Solutions in Delivery Ready State</h1>
            </div>
            <table className="solutions-table">
                <thead>
                    <tr>
                        {solutionColumns.map((col) => (
                            <th key={col.key}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {solutions.map((solution) => (
                        <tr key={solution.solutionId}>
                            {solutionColumns.map((col) => {
                                if (col.isClickable) {
                                    return (
                                        <td
                                            key={col.key}
                                            className="clickable"
                                            onClick={() => openDetailsPopup(solution.solutionId, solution.licenses, solution.mbns)}
                                        >
                                            {solution[col.key]}
                                        </td>
                                    );
                                }

                                return <td key={col.key}>{solution[col.key] || col.defaultValue || ""}</td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>

            {detailsPopup &&  (
                <div className="details-popup">
                    <div className="popup-content">
                        <h3>License Details for Solution ID #{detailsPopup.solutionId}</h3>
                        <table className="details-table">
                            <thead>
                                <tr>
                                    {[
                                        { key: "licenseId", label: "License Id" },
                                        { key: "description", label: "License Description" },
                                        { key: "chipset", label: "Chipset", defaultValue: "-" },
                                        { key: "oem", label: "OEM", defaultValue: "-" },
                                        { key: "features", label: "Features" },
                                    ].map((col) => (
                                        <th key={col.key}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {detailsPopup.licenses.map((license) => (
                                    <tr key={license.licenseId}>
                                        <td>{license.licenseId}</td>
                                        <td>{license.description}</td>
                                        <td>{license.chipset || "-"}</td>
                                        <td>{license.oem || "-"}</td>
                                        <td>{license.features.map((feature) => feature.description).join(", ")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="spacing" />

                        <h3>Delta MBN Details for Solution ID #{detailsPopup.solutionId}</h3>

                        <table className="details-table">
                            <thead>
                                <tr>
                                    {[
                                        { key: "mbnFileId", label: "Delta MBN File Id" },
                                        { key: "description", label: "Delta Description" },
                                        { key: "mbnIdHash", label: "Delta MBN ID Hash" },
                                        { key: "fileName", label: "File Name" },
                                        { key: "chipset", label: "Chipset", defaultValue: "-" },
                                    ].map((col) => (
                                        <th key={col.key}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {detailsPopup.mbns.map((mbn) => (
                                    <tr key={mbn.mbnFileId}>
                                        <td>{mbn.mbnFileId}</td>
                                        <td>{mbn.description}</td>
                                        <td>{mbn.mbnIdHash || "-"}</td>
                                        <td>{mbn.fileName || "-"}</td>
                                        <td>{mbn.chipset || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button className="close-popup-button" onClick={closeDetailsPopup}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
}


export default DeliveryReadySolutionDetailsTab;